// @flow

export default async (name: string): Promise<() => mixed> =>
	// eslint-disable-next-line prefer-template
	import('Widget/Widgets/' + name + '/Edit');
